import React from "react";

import WarningTooltip from "../../../components/WarningTooltip";
import {PrimaryButton} from "../../../components/Buttons";
import {CONFIRMATION_STATE} from "../constants";

const couldBeSkipped = (step) => step && !step.noSkipBtn && step.confirmationState !== CONFIRMATION_STATE.CONFIRMED

export const useStepSkipping = (currService, setLoading, syncOnboardingData, updateState, handleError, guardUnsaved, step) => {
  const handleSkipClick = guardUnsaved(async () => {
    try {
      setLoading(true);
      syncOnboardingData(await currService.skipStep());
      await updateState(true);
      setLoading(false);
    } catch (error) {
      handleError(error);
    }
  })

  const skipBtn = couldBeSkipped(step) ? (
    <PrimaryButton
      text={<>
        Überspringen & weiter<WarningTooltip title={'Sie können diesen Schritt überspringen und später zurückkehren. Fehlende Pflichtfelder werden markiert. Sind alle Angaben vollständig, bestätigen Sie den Schritt später mit “Speichern & weiter“.'} />
      </>}
      variant={"outlined"}
      onButtonClick={handleSkipClick}
    />
  ) : undefined

  return {
    handleSkipClick,
    skipBtn,
  }
}